import PaginatedTable from "../../../components/Block/Table/PaginatedTable";
import LoadSpinner from "../../../components/Common/LoadSpinner";
import Pagination from "../../../components/Block/Pagination/Pagination";
import React, {useState} from "react";
import {useParams} from "react-router-dom";
import AddEditModal from "./AddEditModal";
import {adminGetMAVRecords, deleteMavData} from "../../../services/api/admin";
import {Edit, Trash} from "react-feather";
import LogoAvatar from "../../../components/Item/LogoAvatar";
import ConfirmationModal from "../../../components/Modal/ConfirmationModal";

import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

const MAVPage = () => {

    const headers = [
        {data: 'ID', classes: ""},
        {data: 'MAV Data', classes: "sl-max-w-650px"},
    ]; // Table headers

    const [selectedDeleteRow, setSelectedDeleteRow] = useState(null); // Selected row data for delete
    const [selectedRow, setSelectedRow] = useState(null); // Selected row data
    const [openModal, setOpenModal] = useState(false);
    const {page, per_page} = useParams();
    const [dataFetched, setDataFetched] = useState(false);
    const [dataPagination, setDataPagination] = useState({
        total: 0,
        count: 0,
        per_page: parseInt(per_page, 10) || 10,
        current_page: parseInt(page, 1) || 1,
        total_pages: 1
    });
    const [activeFilterOptions, setActiveFilterOptions] = useState({
        page: dataPagination.current_page,
        per_page: dataPagination.per_page,
        status: sessionStorage.getItem('mavStatus') || 'upcoming'
    });

    const [mavData, setMavData] = useState([]);

    const handleEventFilterChange = (event) => {
        const selectedStatus = event.target.value;
        setActiveFilterOptions((prev) => ({
            ...prev,
            status: selectedStatus,
            page: 1
        }));
        sessionStorage.setItem('mavStatus', selectedStatus);
        setDataFetched(false);
        setMavData([]);
    };

    const MAVRow = ({data}) => {

        let youtubeLink = data.video_link || '';
        if (youtubeLink.includes('youtube.com') && !youtubeLink.includes('embed')) {
            youtubeLink = youtubeLink.replace('watch?v=', 'embed/');
        }

        let vimeoLink = 'https://player.vimeo.com/video/[video_id]';
        if (data.video_link?.includes('vimeo.com')) {
            const videoId = data.video_link.split('/').pop();
            vimeoLink = vimeoLink.replace('[video_id]', videoId);

        }

        return <div className="sl-flex sl-flex-col sl-gap-3 sl-align-flex-start sl-relative">

            <div className={"sl-display-flex sl-align-flex-start sl-flex-row sl-gap-2 "}>
                <span>Vendor: </span>
                <LogoAvatar slug={data.vendor.slug} logo={data.vendor.favico}
                            avatarClass="sl-h-6 sl-w-6"/>
                <span className={"sl-text-gray-900 sl-font-semibold"}>{data.vendor.name}</span>

            </div>

            <span>Title: <span className={"sl-text-gray-900 sl-font-semibold"}>{data.title}</span></span>

            <span className={`sl-text-left`}>
                <span>Products:</span>
                <span className={`sl-flex sl-font-semibold sl-text-gray-900`}>
                    {data.products.length > 0 ? data.products.map(product => (
                        <div key={product.id} className="sl-mr-2 sl-bg-gray-100 sl-rounded sl-p-2 sl-mt-2">
                            {product.name}
                        </div>
                    )) : 'No products selected'}
                </span>
            </span>

            <span>Start: <span className={"sl-text-gray-900 sl-font-semibold"}>{data.start_datetime}</span></span>

            <span>End: <span className={"sl-text-gray-900 sl-font-semibold"}>{data.end_datetime}</span></span>

            {data.presenters?.length > 0 && <span className={`sl-text-left`}>
                <span>Presenters:</span>
                <span className={`sl-flex`}>
                    {data.presenters.length > 0 && data.presenters.map(presenter => (
                        <div
                            key={presenter.id}
                            className="sl-mr-2 sl-bg-gray-100 sl-rounded sl-p-4 sl-mt-2 sl-min-w-56 sl-w-fit-content sl-max-w-64"
                        >
                            <div>
                                <span>Name: </span>
                                <span className="sl-block sl-font-semibold sl-text-gray-900 sl-break-words">{presenter.name}</span>
                            </div>
                            <div className={`sl-mt-2`}>
                                <span>Title: </span>
                                <span className="sl-block sl-font-semibold sl-text-gray-900 sl-break-words">{presenter.title}</span>
                            </div>
                            <div className={`sl-mt-2`}>
                                <span>Profile photo: </span>
                                {presenter.photo != null && <div className="sl-flex sl-flex-row sl-gap-2">
                                    <LightGallery plugins={[lgZoom, lgVideo]} mode="lg-fade"
                                                  elementClassNames={"sl-display-flex sl-flex-row sl-max-w-250"}>
                                        <button
                                            className="gallery-item"
                                            data-src={presenter.photo.preview}
                                            data-sub-html={presenter.photo.name}
                                        >
                                            <img
                                                className="img-responsive sl-mr-3 sl-h-24 sl-cursor-pointer"
                                                alt={presenter.photo.name}
                                                src={presenter.photo.preview}
                                            />
                                        </button>
                                    </LightGallery>
                                </div>}
                            </div>
                        </div>
                    ))}
                </span>
            </span>}

            <span className={"sl-text-left"}>Description: <span
                className={"sl-text-gray-900 sl-font-semibold"}>{data.description} </span></span>

            <span>Registration link: <span className={"sl-text-gray-900 sl-font-semibold"}>
                    {data.registration_link ?
                        <a rel="noreferrer" target="_blank" href={data.registration_link}>{data.registration_link}</a> :
                        <span>Not set</span>}
                </span>
            </span>

            <span>Vendor-only webinar: <span className={"sl-text-gray-900 sl-font-semibold"}>{data.is_vendor_invite ? 'Yes' : 'No'}</span></span>

            {data.featured_image && <div className={"sl-display-flex sl-align-flex-start sl-flex-col"}>
                <span>Featured Image: </span>
                <div className="sl-flex sl-flex-row sl-gap-2 ">
                    <LightGallery plugins={[lgZoom, lgVideo]} mode="lg-fade"
                                  elementClassNames={"sl-flex sl-gap-1 sl-flex-row sl-max-w-250 sl-overflow-auto"}>
                        <button
                            className="gallery-item"
                            data-src={data.featured_image.preview}
                            data-sub-html={data.featured_image.name}
                        >
                            <img
                                alt={data.featured_image.name}
                                className="img-responsive sl-mr-3 sl-h-24 sl-cursor-pointer"
                                src={data.featured_image.preview}
                            />
                        </button>
                    </LightGallery>
                </div>
            </div>}


            {data.images?.length > 0 && <div className={"sl-display-flex sl-align-flex-start sl-flex-col"}>
                <span>Uploads: </span>
                <div className="sl-flex sl-flex-row sl-gap-2 ">
                    <LightGallery plugins={[lgZoom, lgVideo]} mode="lg-fade"
                                  elementClassNames={"sl-display-flex sl-flex-row sl-max-w-250 sl-overflow-auto sl-gap-2"}>
                        {data.images?.map((upload) => (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a
                                className="gallery-item"
                                data-src={upload.preview}
                                data-sub-html={upload.name}
                            >
                                <img
                                    style={{objectFit: 'contain'}}
                                    alt={upload.name}
                                    className="img-responsive sl-mr-3 sl-h-24 sl-cursor-pointer"
                                    src={upload.preview}
                                />
                            </a>


                        ))}
                    </LightGallery>
                </div>
            </div>}

            {data.video_link && <div className={"sl-display-flex sl-align-flex-start sl-flex-col"}>
                <span>Video Link: <a href={data.video_link}>{data.video_link}</a></span>

                {data.video_link.includes('vimeo.com') &&
                    <iframe title={"vimeo video"} width="100%" height="200" src={vimeoLink}
                            allow="autoplay; encrypted-media" allowFullScreen=""/>}


                {youtubeLink.includes('youtube.com') &&
                    <iframe title={"youtube video"} width="100%" height="200"
                            src={youtubeLink}/>}

            </div>}


            <div className="sl-absolute sl-right-0 sl-flex sl-flex-row sl-gap-2">
                <Edit size={15} onClick={() => {
                    setSelectedRow(data)
                    setOpenModal(true)
                }}
                      className="sl-cursor-pointer"
                />

                <Trash size={15} onClick={() => {
                    setSelectedDeleteRow(data)
                }}
                       className="sl-cursor-pointer"
                />
            </div>

        </div>
    };

    const fetchMAVRecords = async () => {

        try {
            const {data, meta} = await adminGetMAVRecords(activeFilterOptions);
            setDataFetched(true);

            const transformedData = data.map((item) => ({
                id: {data: item.id, classes: "sl-w-20"},
                'MAV Data': {
                    data: <MAVRow data={item}/>,
                    classes: "sl-max-w-650px"
                },

            }));
            setMavData(transformedData);
            setDataPagination(meta.pagination);
            setActiveFilterOptions((prev) => ({
                ...prev,
                page: meta.pagination.current_page,
                per_page: meta.pagination.per_page
            }));

        } catch (e) {
            console.error('Error fetching conversations:', e);
        }
    }

    React.useEffect(() => {
            if (!mavData.length && !dataFetched)
                fetchMAVRecords(activeFilterOptions).catch(console.error);
        }
        ,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [activeFilterOptions, dataFetched]);

    React.useEffect(() => {
            if (page && per_page) {
                setDataFetched(false);
                setMavData([]);
                setActiveFilterOptions((prev) => ({
                    ...prev,
                    page: page,
                    per_page: per_page
                }));
                window.scrollTo(0, 0);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, per_page]);

    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className="sl-container sl-m-auto sl-my-8 sl-relative sl-flex sl-flex-col">
                    <div className={"sl-flex sl-flex-row sl-justify-space-between sl-align-center"}>
                        <h1 className={"sl-text-left"}>Meet a Vendor</h1>

                        <div>
                            <select
                                onChange={handleEventFilterChange}
                                value={activeFilterOptions.status}
                                className="sl-select sl-bg-white sl-border sl-border-gray-300 sl-rounded-md sl-mr-2 sl-btn-lg"
                            >
                                <option value="upcoming">Upcoming</option>
                                <option value="past">Past</option>
                            </select>

                            <button
                                onClick={() => {
                                    setOpenModal(true);
                                    setSelectedRow(null);
                                }}
                                className="sl-btn sl-btn-primary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font ">

                                Add New
                            </button>
                        </div>
                    </div>

                    {dataFetched ? (
                        <div className="sl-table-container">
                            <PaginatedTable
                                headers={headers}
                                data={mavData}
                            />
                        </div>
                    ) : (
                        <div className="sl-self-center sl-mt-3 sl-mb-21">
                            <LoadSpinner/>
                        </div>
                    )}
                    {dataPagination.total_pages > 1 && (
                        <Pagination paginationData={dataPagination}
                                    basePath={`/admin/marketing/mav`}
                                    paginator={dataPagination}/>
                    )}

                    {selectedDeleteRow && <ConfirmationModal
                        title={`Delete MAV Record - ID: ${selectedDeleteRow.id}`}
                        message={`Are you sure you want to delete this record?`}
                        handleConfirm={async () => {
                            await deleteMavData(selectedDeleteRow.id);
                            setMavData([]);
                            setDataFetched(false);
                            setSelectedDeleteRow(null);
                        }}
                        handleClose={() => setSelectedDeleteRow(null)}
                    />}


                    {openModal && <AddEditModal
                        fetchMAVRecords={fetchMAVRecords}
                        data={selectedRow} onClose={() => {
                        setOpenModal(false);
                        setSelectedRow(null);
                    }}/>}
                </div>
            </main>
        </div>
    );
}

export default MAVPage;
